import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { NotProteced } from "../components/HomeProtect/NotProteced";
import { Protected } from "../components/HomeProtect/Protected";
import UserStore from "../store/user-store";
import { observer } from "mobx-react-lite";
import { TrialBanner } from "../components/HomeProtect/Banners/TrialBanner";
import DeGuardIcon from "../components/Icons/DeGuardIcon";
import { CasinoBanner } from "../components/HomeProtect/Banners/CasinoBanner";
import {NewsBanner} from "../components/HomeProtect/Banners/NewsBanner";
import {ReferralBanner} from "../components/HomeProtect/Banners/ReferralBanner";
import ConnectionStatus from "../components/ConnectionStatus/ConnectionStatus";
import "./Homepage.css";
import {useNavigate} from "react-router-dom";

export const Homepage = observer(() => {
  const TG_WEB_APP = window.Telegram.WebApp;
  let userName = window.Telegram.WebApp.initDataUnsafe?.user?.username;
  const userAvatarUrl = TG_WEB_APP.initDataUnsafe.user?.photo_url;
  const [showReferralPopup, setShowReferralPopup] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const navigate = useNavigate();
  // Переводы для попапа
  const translations = {
    en: {
      popupTitle: "🎉 New Referral Program!",
      feature1Title: "Earn from referrals",
      feature1Desc: "Invite friends and get up to 15% commission",
      feature2Title: "Growing levels",
      feature2Desc: "More referrals = higher commission",
      feature3Title: "Instant payments",
      feature3Desc: "Get money immediately after conversion",
      primaryButton: "Learn more",
      secondaryButton: "Later",
      alertMessage: "Referral program is available in the app menu!"
    },
    ru: {
      popupTitle: "🎉 Новая реферальная программа!",
      feature1Title: "Зарабатывайте на рефералах",
      feature1Desc: "Приглашайте друзей и получайте до 15% комиссии",
      feature2Title: "Растущие уровни",
      feature2Desc: "Больше рефералов = выше комиссия",
      feature3Title: "Мгновенные выплаты",
      feature3Desc: "Получайте деньги сразу после конверсии",
      primaryButton: "Узнать больше",
      secondaryButton: "Позже",
      alertMessage: "Реферальная программа доступна в меню приложения!"
    }
  };

  const lang = translations[UserStore.langCode] || translations.en;

  // Проверяем, показывали ли мы уже попап
  useEffect(() => {
    const hasSeenReferralPopup = localStorage.getItem('hasSeenReferralPopup');
    if (!hasSeenReferralPopup) {
      // Показываем попап сразу
      setShowReferralPopup(true);
      localStorage.setItem('hasSeenReferralPopup', 'true');
    }
  }, []);

  const handleCloseReferralPopup = () => {
    setIsClosing(true);
    // Задержка перед полным закрытием для завершения анимации
    // setTimeout(() => {
      setShowReferralPopup(false);
      setIsClosing(false);
    // }, 300); // Время анимации закрытия
  };

  const handleGoToReferrals = () => {
    navigate('/referrals');
    // setShowReferralPopup(false);
  };

  // Анимации для попапа
  const overlayVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 }
  };

  const popupVariants = {
    hidden: { 
      opacity: 0, 
      scale: 0.8,
      y: 50
    },
    visible: { 
      opacity: 1, 
      scale: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    },
    exit: { 
      opacity: 0, 
      scale: 0.8,
      y: 50,
      transition: {
        duration: 0.2,
        ease: "easeIn"
      }
    }
  };

  const featureVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: {
        duration: 0.3
      }
    },
    exit: { 
      opacity: 0, 
      x: -20,
      transition: {
        duration: 0.2
      }
    }
  };

  const contentVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.3
      }
    },
    exit: { 
      opacity: 0, 
      y: 20,
      transition: {
        duration: 0.2
      }
    }
  };

  const ReferralPopup = () => {
    return (
      <AnimatePresence>
        {showReferralPopup && (
          <motion.div 
            className="referral-popup-overlay"
            variants={overlayVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={handleCloseReferralPopup}
          >
            <motion.div 
              className="referral-popup"
              variants={popupVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              onClick={(e) => e.stopPropagation()}
            >
              <motion.button 
                className="referral-popup-close" 
                onClick={handleCloseReferralPopup}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                ×
              </motion.button>
              
              <div className="referral-popup-content">
                <motion.div 
                  className="referral-popup-icon"
                  initial={{ scale: 0, rotate: -180 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{ delay: 0.1, duration: 0.5, type: "spring" }}
                >
                  <svg width="48" height="48" viewBox="0 0 121 80" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M48.2196 22.986C48.2196 32.5747 40.9859 39.9766 32.799 39.9766C24.6681 39.9766 17.3785 32.5747 17.3785 23.0981C17.3785 13.5654 24.6681 6.5 32.799 6.5C40.9859 6.5 48.2196 13.3971 48.2196 22.986ZM41.159 79.9017H8.68687C2.68689 79.9017 0.5 77.5466 0.5 73.5653C0.5 61.4532 12.9486 46.7056 32.799 46.7056C40.0315 46.7056 46.2796 48.6523 51.3038 51.7122C43.9216 58.1861 39.7528 66.4514 39.7528 73.9019C39.7528 75.9955 40.1618 78.065 41.159 79.9017Z"
                          fill="white"/>
                    <path
                        d="M83.3779 38.9672C92.7984 38.9672 101.097 30.4999 101.097 19.4532C101.097 8.46261 92.7984 0.5 83.3779 0.5C74.0134 0.5 65.7143 8.6869 65.7143 19.5653C65.7143 30.4999 74.0134 38.9672 83.3779 38.9672ZM56.2938 79.9017H110.518C118.032 79.9017 120.5 77.7709 120.5 73.9017C120.5 62.5186 106.256 46.8176 83.3779 46.8176C60.5554 46.8176 46.3125 62.5186 46.3125 73.9017C46.3125 77.7709 48.7797 79.9017 56.2938 79.9017Z"
                        fill="white"/>
                  </svg>
                </motion.div>
                
                <motion.h2 
                  className="referral-popup-title"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2, duration: 0.3 }}
                >
                  {lang.popupTitle}
                </motion.h2>
                
                <div className="referral-popup-features">
                  <motion.div 
                    className="referral-popup-feature"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.3, duration: 0.3 }}
                  >
                    <div className="feature-icon">💰</div>
                    <div className="feature-text">
                      <strong>{lang.feature1Title}</strong>
                      <span>{lang.feature1Desc}</span>
                    </div>
                  </motion.div>
                  
                  <motion.div 
                    className="referral-popup-feature"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.4, duration: 0.3 }}
                  >
                    <div className="feature-icon">📈</div>
                    <div className="feature-text">
                      <strong>{lang.feature2Title}</strong>
                      <span>{lang.feature2Desc}</span>
                    </div>
                  </motion.div>
                  
                  <motion.div 
                    className="referral-popup-feature"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: 0.5, duration: 0.3 }}
                  >
                    <div className="feature-icon">⚡</div>
                    <div className="feature-text">
                      <strong>{lang.feature3Title}</strong>
                      <span>{lang.feature3Desc}</span>
                    </div>
                  </motion.div>
                </div>
                
                <motion.div 
                  className="referral-popup-actions"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6, duration: 0.3 }}
                >
                  <motion.button 
                    className="referral-popup-btn-primary" 
                    onClick={handleGoToReferrals}
                    whileHover={{ scale: 1.05, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {lang.primaryButton}
                  </motion.button>
                  <motion.button 
                    className="referral-popup-btn-secondary" 
                    onClick={handleCloseReferralPopup}
                    whileHover={{ scale: 1.05, y: -2 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {lang.secondaryButton}
                  </motion.button>
                </motion.div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    );
  };

  const NewsBannerCarousel = observer(() => {
    const containerRef = useRef(null);
    const autoScrollRef = useRef(null);
    const [newsBannerIndex, setNewsBannerIndex] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const newsBanners = [
      <ReferralBanner />,
      <NewsBanner />,
    ];

    const scrollToNextNewsBanner = () => {
      if (!containerRef.current || isDragging) return;
      const container = containerRef.current;
      const bannerWidth = container.clientWidth;
      const nextIndex = (newsBannerIndex + 1) % newsBanners.length;
      setNewsBannerIndex(nextIndex);
      container.scrollTo({
        left: nextIndex * bannerWidth,
        behavior: "smooth",
      });
    };

    // Mouse drag handlers
    const handleMouseDown = (e) => {
      if (!containerRef.current) return;
      setIsDragging(true);
      setStartX(e.pageX - containerRef.current.offsetLeft);
      setScrollLeft(containerRef.current.scrollLeft);
      
      // Pause auto-scroll while dragging
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
      }
    };

    const handleMouseMove = (e) => {
      if (!isDragging || !containerRef.current) return;
      e.preventDefault();
      const x = e.pageX - containerRef.current.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
      if (!isDragging || !containerRef.current) return;
      setIsDragging(false);
      
      // Snap to nearest banner
      const container = containerRef.current;
      const bannerWidth = container.clientWidth;
      const currentScroll = container.scrollLeft;
      const targetIndex = Math.round(currentScroll / bannerWidth);
      const clampedIndex = Math.max(0, Math.min(targetIndex, newsBanners.length - 1));
      
      setNewsBannerIndex(clampedIndex);
      container.scrollTo({
        left: clampedIndex * bannerWidth,
        behavior: "smooth",
      });
      
      // Resume auto-scroll
      autoScrollRef.current = setInterval(scrollToNextNewsBanner, 4000);
    };

    useEffect(() => {
      autoScrollRef.current = setInterval(scrollToNextNewsBanner, 4000);
      return () => {
        if (autoScrollRef.current) {
          clearInterval(autoScrollRef.current);
        }
      };
    }, [newsBannerIndex, isDragging]);

    const handlePause = () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
      }
    };

    const handleResume = () => {
      if (!isDragging) {
        autoScrollRef.current = setInterval(scrollToNextNewsBanner, 4000);
      }
    };

    return (
      <div
        ref={containerRef}
        className="user_data__items__item"
        onMouseEnter={handlePause}
        onMouseLeave={handleResume}
        onTouchStart={handlePause}
        onTouchEnd={handleResume}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={() => {
          setIsDragging(false);
          handleResume();
        }}
        style={{ 
          cursor: isDragging ? 'grabbing' : 'grab',
          userSelect: isDragging ? 'none' : 'auto'
        }}
        className={isDragging ? 'user_data__items__item dragging' : 'user_data__items__item'}
      >
        {newsBanners.map((banner, index) => (
          <div key={index} style={{ minWidth: '100%' }}>
            {banner}
          </div>
        ))}
      </div>
    );
  });

  const BannerCarousel = observer(() => {
    const containerRef = useRef(null);
    const autoScrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const banners = [
      UserStore.can_activate_trial && !UserStore.is_trial_activated && (
        <TrialBanner />
      ),
      UserStore.userActivePlanData ? (
        UserStore.userActivePlanData
          .filter((el) => el.status)
          .map((el) => <Protected props={el} />)
      ) : (
        <NotProteced />
      ),
      <CasinoBanner />,
    ];

    const scrollToNextBanner = () => {
      if (!containerRef.current || isDragging) return;
      const container = containerRef.current;
      const bannerWidth = container.clientWidth;
      const nextIndex = (UserStore.banner_index + 1) % banners.length;
      UserStore.setBannerIndex(nextIndex);
      container.scrollTo({
        left: nextIndex * bannerWidth,
        behavior: "smooth",
      });
    };

    // Mouse drag handlers
    const handleMouseDown = (e) => {
      if (!containerRef.current) return;
      setIsDragging(true);
      setStartX(e.pageX - containerRef.current.offsetLeft);
      setScrollLeft(containerRef.current.scrollLeft);
      
      // Pause auto-scroll while dragging
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
      }
    };

    const handleMouseMove = (e) => {
      if (!isDragging || !containerRef.current) return;
      e.preventDefault();
      const x = e.pageX - containerRef.current.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
      if (!isDragging || !containerRef.current) return;
      setIsDragging(false);
      
      // Snap to nearest banner
      const container = containerRef.current;
      const bannerWidth = container.clientWidth;
      const currentScroll = container.scrollLeft;
      const targetIndex = Math.round(currentScroll / bannerWidth);
      const clampedIndex = Math.max(0, Math.min(targetIndex, banners.length - 1));
      
      UserStore.setBannerIndex(clampedIndex);
      container.scrollTo({
        left: clampedIndex * bannerWidth,
        behavior: "smooth",
      });
      
      // Resume auto-scroll
      autoScrollRef.current = setInterval(scrollToNextBanner, 5000);
    };

    useEffect(() => {
      autoScrollRef.current = setInterval(scrollToNextBanner, 5000);
      return () => {
        if (autoScrollRef.current) {
          clearInterval(autoScrollRef.current);
        }
      };
    }, [UserStore.banner_index, isDragging]);

    const handlePause = () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
      }
    };

    const handleResume = () => {
      if (!isDragging) {
        autoScrollRef.current = setInterval(scrollToNextBanner, 5000);
      }
    };

    useEffect(() => {
      const savedIndex = UserStore.banner_index;
      if (savedIndex) {
        UserStore.setBannerIndex(savedIndex);
      }
    }, []);

    return (
      <div
        ref={containerRef}
        className="user_data__items__item"
        onMouseEnter={handlePause}
        onMouseLeave={handleResume}
        onTouchStart={handlePause}
        onTouchEnd={handleResume}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={() => {
          setIsDragging(false);
          handleResume();
        }}
        style={{ 
          cursor: isDragging ? 'grabbing' : 'grab',
          userSelect: isDragging ? 'none' : 'auto'
        }}
        className={isDragging ? 'user_data__items__item dragging' : 'user_data__items__item'}
      >
        {banners.map((banner, index) => banner)}
      </div>
    );
  });

  return (
    <div className="home_page">
      <ConnectionStatus/>
      <div className="user_data">
        <div className="user_data__header">
          <div className="user_data__header__user_profile">
            <div className="user_image">
              {userAvatarUrl ? (
                <img
                  src={userAvatarUrl}
                  className="user_image__name"
                  alt="User Avatar"
                />
              ) : (
                <DeGuardIcon className="user_image__name" />
              )}
            </div>

            <div className="user_data__header__user_profile__user_name">
              <p>{userName ? userName : "Username"}</p>
              <button onClick={() => UserStore.setSettingWindow(true)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M10.9648 23.9998H13.0207C13.6039 23.9998 14.0413 23.6498 14.1725 23.0812L14.7703 20.5295C15.2515 20.3691 15.7035 20.1942 16.1118 19.99L18.3426 21.3606C18.8092 21.6522 19.3779 21.6085 19.7716 21.2148L21.2151 19.7713C21.6087 19.3776 21.667 18.7798 21.3463 18.2987L19.9903 16.0824C20.1944 15.6741 20.384 15.2221 20.5152 14.7993L23.096 14.1869C23.6501 14.0702 23.9854 13.6328 23.9854 13.035V11.0228C23.9854 10.4542 23.6501 10.0168 23.096 9.90012L20.5443 9.27314C20.384 8.77741 20.1798 8.33997 20.0194 7.97545L21.3755 5.71545C21.6817 5.23426 21.6525 4.68021 21.2442 4.27195L19.7716 2.82844C19.3633 2.46392 18.8675 2.39103 18.3864 2.65349L16.1118 4.05324C15.7181 3.84911 15.2661 3.67412 14.7703 3.51373L14.1725 0.918355C14.0413 0.349703 13.6039 -0.000244141 13.0207 -0.000244141H10.9648C10.3815 -0.000244141 9.94409 0.349703 9.82746 0.918355L9.21506 3.48459C8.74847 3.64497 8.26731 3.81993 7.87362 4.03864L5.61362 2.65349C5.11786 2.39103 4.62213 2.44935 4.21386 2.82844L2.74118 4.27195C2.33292 4.68021 2.30377 5.23426 2.60997 5.71545L3.96598 7.97545C3.80559 8.33997 3.60146 8.77741 3.45565 9.27314L0.904008 9.90012C0.335356 10.0168 0 10.4542 0 11.0228V13.035C0 13.6328 0.335356 14.0702 0.904008 14.1869L3.48482 14.7993C3.60146 15.2221 3.79099 15.6741 3.99512 16.0824L2.63911 18.2987C2.31834 18.7798 2.37666 19.3776 2.77036 19.7713L4.21386 21.2148C4.60752 21.6085 5.17617 21.6522 5.65733 21.3606L7.88822 19.99C8.28189 20.1942 8.74847 20.3691 9.21506 20.5295L9.82746 23.0812C9.94409 23.6498 10.3815 23.9998 10.9648 23.9998ZM12 16.0095C9.78371 16.0095 7.99029 14.1869 7.99029 11.9852C7.99029 9.79805 9.78371 7.99006 12 7.99006C14.2017 7.99006 15.9951 9.79805 15.9951 11.9852C15.9951 14.1869 14.2017 16.0095 12 16.0095Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="banners_main">
          <NewsBannerCarousel />
          <BannerCarousel />
        </div>
      </div>
      
      {/* Реферальный попап */}
      <ReferralPopup />
    </div>
  );
});
